export default __webpack_public_path__ + "static/EffertzFamilyBackground-f278c0da32af19e9102a3bfe04f9f90f.png";